import script from "./TentangKami.vue?vue&type=script&setup=true&lang=js"
export * from "./TentangKami.vue?vue&type=script&setup=true&lang=js"

import "./TentangKami.vue?vue&type=style&index=0&id=d28627b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d28627b8"]])

export default __exports__